import * as React from "react";
const SvgBackArrowBlack = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 16, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#000", d: "m7.12.5 1.77 1.86-4.12 4.33H20V9.3H4.77l4.12 4.33-1.77 1.86L0 8.01z" }));
export default SvgBackArrowBlack;
